import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { IconArrowRight } from '@wds/icons';
import { Typography } from '@wds/typography';
import { NavRouteParams } from '~pricing/components/Navigation/types';

import COPY from '~app/pages/Pricing/copy';
import BackToSummary from '~pricing/components/BackToSummary';
import DetailsPackagesView from '~pricing/components/DetailsPackagesView';
import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import DetailsFooter from '~pricing/components/PricingFooter';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import { usePackages } from '~shared/hooks/usePackages';

import useEducationalStyles from './useStyles';

export default function EducationalDetailsPage(): JSX.Element {
  const { ViewPricingLink } = useEducationalStyles();
  const { canonicalPath } = useParams<NavRouteParams>();
  const { displayPackages } = usePackages();
  const { pageUtSource } = useTrackingDetails();

  const path = canonicalPath === 'educational' ? 'individual' : canonicalPath;
  const viewPricingLinkText = t(COPY.VIEW_PRICING);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div key="PricingEducational">
      <header>
        <BackToSummary url={createURL(`/pricing/${path}`, { ut_source: pageUtSource })} />
        <MainHeading>{t(COPY.EDUCATIONAL_HEADING)}</MainHeading>
        <Typography align="center" data-testid="Educational__SubHeading">
          {t(COPY.EDUCATIONAL_SUBHEADING)}{' '}
          <Link className={ViewPricingLink} to={createURL(`/pricing/individual/details/`, { ut_source: pageUtSource })}>
            {viewPricingLinkText}
            <IconArrowRight title={viewPricingLinkText} size="sm" />
          </Link>
        </Typography>
        <Navigation />
      </header>
      <DetailsPackagesView packageData={displayPackages} />
      <DetailsFooter packages={displayPackages} />
    </div>
  );
}
